import { FilterContext } from "../../../interfaces/api/filter";

import client from "../client";
import { generateFilterQuery } from "../helpers";

export function getCompetences(filterContext: FilterContext = []) {
  const query = encodeURI(generateFilterQuery(filterContext));
  return client.get(`/api/v2/competences${query}`);
}
